(function () {
  function clampIndex(i, n) {
    if (n <= 0) return 0;
    if (i < 0) return n - 1;
    if (i >= n) return 0;
    return i;
  }

  function formatMoney(cents, moneyFormat, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      try { return window.Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
    }
    const iso = currency || 'GBP';
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: iso }).format((cents || 0) / 100);
  }

  class PanareaFeaturedCollection {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-pfc-track]');
      this.slides = Array.from(root.querySelectorAll('[data-pfc-slide]'));
      this.prevBtn = root.querySelector('[data-pfc-prev]');
      this.nextBtn = root.querySelector('[data-pfc-next]');
      this.viewport = root.querySelector('[data-pfc-viewport]');
      this.requestLink = root.querySelector('[data-pfc-request-link]');
      this.wholesaleQtyInput = root.querySelector('[data-pfc-wholesale-qty]');
      this.requestPageUrl = root.dataset.requestPageUrl || '/pages/wholesale-order-request';
      this.customerEmail = root.dataset.customerEmail || '';
      this.defaultAddBtnText = this.addBtn ? this.addBtn.textContent.trim() : 'Add to cart';

      this.titleEl = root.querySelector('[data-pfc-title]');
      this.descEl = root.querySelector('[data-pfc-desc]');
      this.priceEl = root.querySelector('[data-pfc-price]');
      this.linkEl = root.querySelector('[data-pfc-link]');

      this.variantInput = root.querySelector('[data-pfc-variant-input]');
      this.addBtn = root.querySelector('[data-pfc-add]');

      // Modal bits (inside this section)
      this.infoBtn = root.querySelector('[data-pfc-info]');
      this.modal = root.querySelector('[data-pfc-modal]');
      this.modalCloseEls = this.modal ? Array.from(this.modal.querySelectorAll('[data-pfc-modal-close]')) : [];
      this.modalSections = this.modal ? Array.from(this.modal.querySelectorAll('[data-pfc-modal-section]')) : [];

      this.modalContent = this.modal
        ? {
            ingredients: this.modal.querySelector('[data-pfc-modal-content="ingredients"]'),
            allergens: this.modal.querySelector('[data-pfc-modal-content="allergens"]'),
            nutrition: this.modal.querySelector('[data-pfc-modal-content="nutrition"]'),
            storage: this.modal.querySelector('[data-pfc-modal-content="storage"]'),
          }
        : null;

      this.moneyFormat = root.dataset.moneyFormat || null;
      this.currency = root.dataset.currency || 'GBP';

      this.index = 0;

      if (!this.track || this.slides.length === 0) return;

      if (this.slides.length <= 1) {
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
      }

      this.bind();
      this.apply(this.index);
    }

    bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      if (this.wholesaleQtyInput) {
        this.wholesaleQtyInput.addEventListener('input', () => {
          const activeSlide = this.slides[this.index];
          this.updateWholesaleRequestLink(activeSlide);
        });
      }

      if (this.viewport) {
        this.viewport.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1);
          if (e.key === 'ArrowRight') this.go(this.index + 1);
        });
      }

      // Swipe
      let startX = null;
      let isDown = false;

      if (this.viewport) {
        this.viewport.addEventListener('pointerdown', (e) => {
          isDown = true;
          startX = e.clientX;
          this.viewport.setPointerCapture(e.pointerId);
        });

        this.viewport.addEventListener('pointerup', (e) => {
          if (!isDown || startX === null) return;
          const dx = e.clientX - startX;
          isDown = false;
          startX = null;

          if (Math.abs(dx) < 30) return;
          if (dx > 0) this.go(this.index - 1);
          else this.go(this.index + 1);
        });

        this.viewport.addEventListener('pointercancel', () => {
          isDown = false;
          startX = null;
        });
      }

      // Modal open
      if (this.infoBtn && this.modal) {
        this.infoBtn.addEventListener('click', () => {
          this.populateModalFromCurrentSlide();
          this.openModal();
        });
      }

      // Modal close (backdrop + X)
      if (this.modal && this.modalCloseEls.length) {
        this.modalCloseEls.forEach((el) => {
          el.addEventListener('click', () => this.closeModal());
        });
      }

      // Escape closes modal
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.modal && this.modal.getAttribute('aria-hidden') === 'false') {
          this.closeModal();
        }
      });
    }

    go(i) {
      this.index = clampIndex(i, this.slides.length);
      this.apply(this.index);
    }

    apply(i) {
      this.track.style.transform = `translateX(-${i * 100}%)`;

      this.slides.forEach((s, idx) => {
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });

      const slide = this.slides[i];
      const title = slide.dataset.title || '';
      const desc = slide.dataset.desc || '';
      const url = slide.dataset.url || '#';
      const variantId = slide.dataset.variantId || '';
      const priceCents = parseInt(slide.dataset.priceCents || '0', 10) || 0;
      const available = (slide.dataset.available || 'false') === 'true';
      

      if (this.titleEl) this.titleEl.textContent = title;
      if (this.descEl) this.descEl.textContent = desc;
      if (this.priceEl) this.priceEl.textContent = formatMoney(priceCents, this.moneyFormat, this.currency);
      if (this.linkEl) this.linkEl.setAttribute('href', url);

      if (this.variantInput) this.variantInput.value = variantId;


      this.updateWholesaleRequestLink(slide);

      if (this.addBtn) {
        this.addBtn.disabled = !available;
        this.addBtn.textContent = available ? this.defaultAddBtnText : 'Sold out';
      }

      // Enable/disable info button based on whether the slide has any info
      if (this.infoBtn) {
        const hasInfo =
          this.getTemplateHtml(slide, '[data-pfc-ing]').length ||
          this.getTemplateHtml(slide, '[data-pfc-nut]').length ||
          this.getTemplateHtml(slide, '[data-pfc-all]').length ||
          this.getTemplateHtml(slide, '[data-pfc-sto]').length;

        this.infoBtn.disabled = !hasInfo;
        this.infoBtn.style.visibility = hasInfo ? 'visible' : 'hidden';
      }
    }

    getTemplateHtml(slide, selector) {
      const t = slide.querySelector(selector);
      if (!t) return '';
      const html = (t.innerHTML || '').trim();
      return html;
    }

    updateWholesaleRequestLink(activeSlide) {
      if (!this.requestLink || !this.wholesaleQtyInput || !activeSlide) return;

      const qty = this.wholesaleQtyInput.value || '1';
      const productTitle = activeSlide.dataset.title || '';
      const priceCents = activeSlide.dataset.priceCents || '';

      const params = new URLSearchParams();
      params.set('source', 'wholesale');
      params.set('product', productTitle);
      params.set('qty', qty);
      params.set('price_cents', priceCents);

      if (this.customerEmail) {
        params.set('email', this.customerEmail);
      }

      this.requestLink.href = `${this.requestPageUrl}?${params.toString()}`;
    }

    populateModalFromCurrentSlide() {
      if (!this.modal || !this.modalContent) return;

      const slide = this.slides[this.index];

      const ingredients = this.getTemplateHtml(slide, '[data-pfc-ing]');
      const allergens = this.getTemplateHtml(slide, '[data-pfc-all]');
      const nutrition = this.getTemplateHtml(slide, '[data-pfc-nut]');
      const storage = this.getTemplateHtml(slide, '[data-pfc-sto]');

      this.setModalSection('ingredients', ingredients);
      this.setModalSection('allergens', allergens);
      this.setModalSection('nutrition', nutrition);
      this.setModalSection('storage', storage);
    }

    setModalSection(key, html) {
      const section = this.modal.querySelector(`[data-pfc-modal-section="${key}"]`);
      const target = this.modalContent[key];
      if (!section || !target) return;

      if (!html) {
        section.style.display = 'none';
        target.innerHTML = '';
        return;
      }

      section.style.display = '';
      target.innerHTML = html;
    }

    openModal() {
      if (!this.modal) return;
      this.modal.setAttribute('aria-hidden', 'false');

      // Focus close button for accessibility
      const closeBtn = this.modal.querySelector('[data-pfc-modal-close]');
      if (closeBtn) closeBtn.focus();
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.setAttribute('aria-hidden', 'true');
    }
  }

  function init() {
    document.querySelectorAll('[data-pfc]').forEach((root) => new PanareaFeaturedCollection(root));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
